const regions = [
 {
  label: 'Arica y Parinacota',
  value: 'AP',
  cities: ['Arica', 'Camarones', 'Putre', 'General Lagos'],
 },
 {
  label: 'Tarapacá',
  value: 'TA',
  cities: [
   'Alto Hospicio',
   'Camiña',
   'Colchane',
   'Huara',
   'Iquique',
   'Pica',
   'Pozo Almonte',
  ],
 },
 {
  label: 'Antofagasta',
  value: 'AN',
  cities: [
   'Antofagasta',
   'Calama',
   'María Elena',
   'Mejillones',
   'Ollagüe',
   'San Pedro de Atacama',
   'Sierra Gorda',
   'Taltal',
   'Tocopilla',
  ],
 },
 {
  label: 'Atacama',
  value: 'AT',
  cities: [
   'Alto del Carmen',
   'Caldera',
   'Chañaral',
   'Copiapó',
   'Diego de Almagro',
   'Freirina',
   'Huasco',
   'Tierra Amarilla',
   'Vallenar',
  ],
 },
 {
  label: 'Coquimbo',
  value: 'CO',
  cities: [
   'Andacollo',
   'Canela',
   'Combarbalá',
   'Coquimbo',
   'Illapel',
   'La Higuera',
   'La Serena',
   'Los Vilos',
   'Monte Patria',
   'Ovalle',
   'Paiguano',
   'Punitaqui',
   'Río Hurtado',
   'Salamanca',
   'Vicuña',
  ],
 },
 {
  label: 'Valparaíso',
  value: 'VS',
  cities: [
   'Algarrobo',
   'Cabildo',
   'Calera',
   'Calle Larga',
   'Cartagena',
   'Casablanca',
   'Catemu',
   'Concón',
   'El Quisco',
   'El Tabo',
   'Hijuelas',
   'Isla de Pascua',
   'Juan Fernández',
   'La Cruz',
   'La Ligua',
   'Limache',
   'Llay Llay',
   'Los Andes',
   'Nogales',
   'Olmué',
   'Panquehue',
   'Papudo',
   'Petorca',
   'Puchuncaví',
   'Putaendo',
   'Quillota',
   'Quilpué',
   'Quintero',
   'Rinconada',
   'San Antonio',
   'San Esteban',
   'San Felipe',
   'Santa María',
   'Santo Domingo',
   'Valparaíso',
   'Villa Alemana',
   'Viña del Mar',
   'Zapallar',
  ],
 },
 {
  label: 'Metropolitana',
  value: 'RM',
  cities: [
   'Alhué',
   'Buin',
   'Calera de Tango',
   'Cerrillos',
   'Cerro Navia',
   'Colina',
   'Conchalí',
   'Curacaví',
   'El Bosque',
   'El Monte',
   'Estación Central',
   'Huechuraba',
   'Independencia',
   'Isla de Maipo',
   'La Cisterna',
   'La Florida',
   'La Granja',
   'La Pintana',
   'La Reina',
   'Lampa',
   'Las Condes',
   'Lo Barnechea',
   'Lo Espejo',
   'Lo Prado',
   'Macul',
   'Maipú',
   'María Pinto',
   'Melipilla',
   'Ñuñoa',
   'Padre Hurtado',
   'Paine',
   'Pedro Aguirre Cerda',
   'Peñaflor',
   'Peñalolén',
   'Pirque',
   'Providencia',
   'Pudahuel',
   'Puente Alto',
   'Quilicura',
   'Quinta Normal',
   'Recoleta',
   'Renca',
   'San Bernardo',
   'San Joaquín',
   'San José de Maipo',
   'San Miguel',
   'San Pedro',
   'San Ramón',
   'Santiago',
   'Talagante',
   'Tiltil',
   'Vitacura',
  ],
 },
 {
  label: 'O’Higgins',
  value: 'LI',
  cities: [
   'Chépica',
   'Chimbarongo',
   'Codegua',
   'Coinco',
   'Coltauco',
   'Doñihue',
   'Graneros',
   'La Estrella',
   'Las Cabras',
   'Litueche',
   'Lolol',
   'Machalí',
   'Malloa',
   'Marchihue',
   'Mostazal',
   'Nancagua',
   'Navidad',
   'Olivar',
   'Palmilla',
   'Paredones',
   'Peralillo',
   'Peumo',
   'Pichidegua',
   'Pichilemu',
   'Placilla',
   'Pumanque',
   'Quinta de Tilcoco',
   'Rancagua',
   'Rengo',
   'Requínoa',
   'San Fernando',
   'San Vicente',
   'Santa Cruz',
  ],
 },
 {
  label: 'Maule',
  value: 'ML',
  cities: [
   'Cauquenes',
   'Chanco',
   'Colbún',
   'Constitución',
   'Curepto',
   'Curicó',
   'Empedrado',
   'Hualañé',
   'Licantén',
   'Linares',
   'Longaví',
   'Maule',
   'Molina',
   'Parral',
   'Pelarco',
   'Pelluhue',
   'Pencahue',
   'Rauco',
   'Retiro',
   'Río Claro',
   'Romeral',
   'Sagrada Familia',
   'San Clemente',
   'San Javier',
   'San Rafael',
   'Talca',
   'Teno',
   'Vichuquén',
   'Villa Alegre',
   'Yerbas Buenas',
  ],
 },
 {
  label: 'Ñuble',
  value: 'NB',
  cities: [
   'Bulnes',
   'Chillán Viejo',
   'Chillán',
   'Cobquecura',
   'Coelemu',
   'Coihueco',
   'El Carmen',
   'Ninhue',
   'Ñiquén',
   'Pemuco',
   'Pinto',
   'Portezuelo',
   'Quillón',
   'Quirihue',
   'Ránquil',
   'San Carlos',
   'San Fabián',
   'San Ignacio',
   'San Nicolás',
   'Treguaco',
   'Yungay',
  ],
 },
 {
  label: 'Biobío',
  value: 'BI',
  cities: [
   'Alto Biobío',
   'Antuco',
   'Arauco',
   'Cabrero',
   'Cañete',
   'Chiguayante',
   'Concepción',
   'Contulmo',
   'Coronel',
   'Curanilahue',
   'Florida',
   'Hualpén',
   'Hualqui',
   'Laja',
   'Lebu',
   'Los Álamos',
   'Los Ángeles',
   'Lota',
   'Mulchén',
   'Nacimiento',
   'Negrete',
   'Penco',
   'Quilaco',
   'Quilleco',
   'San Pedro de la Paz',
   'San Rosendo',
   'Santa Bárbara',
   'Santa Juana',
   'Talcahuano',
   'Tirúa',
   'Tomé',
   'Tucapel',
   'Yumbel',
  ],
 },
 {
  label: 'Araucanía',
  value: 'AR',
  cities: [
   'Angol',
   'Carahue',
   'Cholchol',
   'Collipulli',
   'Cunco',
   'Curacautín',
   'Curarrehue',
   'Ercilla',
   'Freire',
   'Galvarino',
   'Gorbea',
   'Lautaro',
   'Loncoche',
   'Lonquimay',
   'Los Sauces',
   'Lumaco',
   'Melipeuco',
   'Nueva Imperial',
   'Padre las Casas',
   'Perquenco',
   'Pitrufquén',
   'Pucón',
   'Purén',
   'Renaico',
   'Saavedra',
   'Temuco',
   'Teodoro Schmidt',
   'Toltén',
   'Traiguén',
   'Victoria',
   'Vilcún',
   'Villarrica',
  ],
 },
 {
  label: 'Los Ríos',
  value: 'LR',
  cities: [
   'Corral',
   'Futrono',
   'La Unión',
   'Lago Ranco',
   'Lanco',
   'Los Lagos',
   'Máfil',
   'Mariquina',
   'Paillaco',
   'Panguipulli',
   'Río Bueno',
   'Valdivia',
  ],
 },
 {
  label: 'Los Lagos',
  value: 'LL',
  cities: [
   'Ancud',
   'Calbuco',
   'Castro',
   'Chaitén',
   'Chonchi',
   'Cochamó',
   'Curaco de Vélez',
   'Dalcahue',
   'Fresia',
   'Frutillar',
   'Futaleufú',
   'Hualaihué',
   'Llanquihue',
   'Los Muermos',
   'Maullín',
   'Osorno',
   'Palena',
   'Puerto Montt',
   'Puerto Octay',
   'Puerto Varas',
   'Puqueldón',
   'Purranque',
   'Puyehue',
   'Queilén',
   'Quellón',
   'Quemchi',
   'Quinchao',
   'Río Negro',
   'San Juan de la Costa',
   'San Pablo',
  ],
 },
 {
  label: 'Aysén',
  value: 'AY',
  cities: [
   'Aysén',
   'Chile Chico',
   'Cisnes',
   'Cochrane',
   'Coyhaique',
   'Guaitecas',
   'Lago Verde',
   'O’Higgins',
   'Río Ibáñez',
   'Tortel',
  ],
 },
 {
  label: 'Magallanes',
  value: 'MA',
  cities: [
   'Antártica',
   'Cabo de Hornos',
   'Laguna Blanca',
   'Natales',
   'Porvenir',
   'Primavera',
   'Punta Arenas',
   'Río Verde',
   'San Gregorio',
   'Timaukel',
   'Torres del Paine',
  ],
 },
];

class LocationSelector extends HTMLElement {
 constructor() {
  super();
  this.domain = document.getElementById('domain').value;
//   this.termsSwitch = document.getElementById('CartTerms');
  this.provinceSelector = this.querySelector('[name="province"]');
  this.citySelector = this.querySelector('[name="city"]');
  this.checkoutBtn = document.querySelector('button[name="checkout"]');
 }
 connectedCallback() {
  this.provinceSelector.addEventListener('change', (e) => {
   this.proviceChangeHandle(e);
  });
  this.citySelector.addEventListener("change", () => {
   this.validateSelectors();
  });
//   this.termsSwitch.addEventListener('change', () => {
//    this.validateSelectors();
//   });
  this.checkoutBtn.addEventListener('click', async (e) => {
   this.checkout(e);
  });

 }

 proviceChangeHandle(e) {
  const selectedRegion = regions.find(region => region.value === e.target.value);
  if (selectedRegion) {
   this.citySelector.innerHTML = '<option selected disabled value="">Comuna</option>';
   selectedRegion.cities.forEach(city => {
    const option = document.createElement('option');
    option.value = city;
    option.textContent = city;
    this.citySelector.appendChild(option);
   });
  }
  this.citySelector.value = '';
  this.validateSelectors();
 }

 validateSelectors() {
  if (this.provinceSelector.value !== '' &&
   this.citySelector.value !== '' 
   // && this.termsSwitch.checked
) {
   this.checkoutBtn.classList.remove('btn-validate');
   return true
  } else if (
   (this.provinceSelector.value === '' || this.citySelector.value === '') 
   // && this.termsSwitch.checked
) {
   return false
  } else {
   this.checkoutBtn.classList.add('btn-validate');
   return false
  }
 }

 async checkout(e) {
  e.preventDefault();
  const validate = this.validateSelectors();
  if (validate) {
   let url = '';
   const cart = await fetch('/cart.js');
   const { items } = await cart.json();
   let products = await items.map(item => `${item.id}:${item.quantity}`).join(',');

   url = `https://${this.domain}/cart/${products}?checkout[shipping_address][country]=CL&checkout[shipping_address][province]=${this.provinceSelector.value}&checkout[shipping_address][city]=${this.citySelector.value}`;
   window.location.href = url;
  } else {
   alert('Debes Debes seleccionar la región y comuna para avanzar todos los campos.');
  }
 }
}
customElements.define('location-selector', LocationSelector);